import { css } from 'styled-components';
import { color, flexbox, layout, space, typography } from 'styled-system';
import { breakText, font, ignoredProps, linkEffect, linkHoverEffect, } from '@design-system/theme';
export const getLinkStyle = () => css `
  ${space}
  ${flexbox}
  ${font}
  ${typography}
  ${color}
  ${layout}

  ${({ styledOnlyOnHover }) => styledOnlyOnHover ? linkHoverEffect : linkEffect}
  ${({ enableWrap }) => (enableWrap ? breakText : undefined)}
`;
export const ignoredPropsConfig = {
    shouldForwardProp: (prop) => ![
        ...ignoredProps,
        'enableWrap',
        'styledOnlyOnHover',
        'isDisabled',
        'theme',
    ].includes(prop),
};
//# sourceMappingURL=style.js.map